<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.5L3.76471 10.5H12.2353L14 4.5L10.8235 6.83333L8 3.5L5.17647 6.83333L2 4.5Z"
      fill="#D8D8D8"
    />
    <path
      d="M3.76471 12.5H12.2353M3.76471 10.5L2 4.5L5.17647 6.83333L8 3.5L10.8235 6.83333L14 4.5L12.2353 10.5H3.76471Z"
      stroke="#D8D8D8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
